<template>
    <div class="font-poppin">
        <div class="container filter-contents">
            <div class="my-3">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="input-title text-secondary ml-3">Territory</span>
                    <span class="input-title text-secondary ml-3 pointer" @click="closeCountry()">
                        <i class="icon icon-close-circle fs-18 text-secondary"></i>
                    </span>
                </div>
                <div class="d-flex align-content-center mt-3">
                    <multiselect autocomplete="off" v-validate="'required'" @search-change="searchTerritories" :loading="territories_loading"
                        class="diginew-multiselect new-align-multi no-default-icon down-arrow" open-direction="bottom"
                        :searchable="true"  name="name" label="name" v-model="territory" :options="territories" placeholder="Select Territory">
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfTerritories" />
                        </template>
                        <template slot="noOptions">
                            <div class="text-secondary text-center font-weight-bold">Territories Not Found</div>
                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Data Found</div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="my-3">
                <span class="input-title text-secondary ml-3">Country</span>
                <div class="d-flex align-content-center mt-3">
                    <multiselect autocomplete="off" v-validate="'required'" v-model="country"
                        class="diginew-multiselect new-align-multi no-default-icon down-arrow text-secondary"
                        :searchable="true" :options="countries" placeholder="Select Country">
                    </multiselect>
                </div>
            </div>
            <div class="my-3" style="text-align: end !important;">
                <button class="btn btn-new-primary btn-wide px-6 ml-4" @click="updateTerritoryCountry"> Apply</button>
            </div>
        </div>
    </div>
</template>

<script>
import countries from "../json/countries.json";
import deals from "../mixins/deals";
import { debounce } from 'lodash'
export default {
    mixins:[deals],
    props: ["sales_forecast_details"],
    data() {
        return {
            countries: countries,
            country: null,
            territories_count: 0,
            territories_loading:false,
            territories_scrollable :false,
            territories_visible: false,
            territory: "",
            temp_territories: [],
            territories: [],
        }
    },
    methods: {
        updateTerritoryCountry(){
            this.$emit("updateCountry",this.country)
            this.$emit("updateTerritory",this.territory)
        },
        closeCountry(){
            this.$emit("closeCountry")
        },
        updateTerritory(territory){
            this.$emit("updateTerritory",this.territory)
        },
        async searchTerritoriesDebouncer(search_key) {
            this.territories_loading = true
            try {
                let params = {
                    skip: 0,
                    limit: 10
                };
                let response = await this.getTerritoryList(params)
                this.territories = response.response;
                this.territories_count = response.response.length;
                this.territories_loading = false
            }
            catch(error) {
            }
        },
        async reachedEndOfTerritories(reached) {
            this.territories_visible = reached
            if (reached) {
                if (this.territories_scrollable == false) {
                    this.territories_loading = true
                    let response = await this.getTerritoryList({
                        skip: this.territories_count,
                        limit: 10
                    })
                    this.temp_territories = response.response.length;
                    if (response.skip == this.territories_count) {
                        if (this.temp_territories > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.territories.push(el);
                            });
                            this.territories = this.territories.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.territories.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.territories_count += response.response.length;
                            this.territories_loading = false
                        } else {
                            this.territories_scrollable = true
                            this.territories_loading = false
                        }
                    }
                    this.territories_loading = false
                }
            }
        },
    },
    created(){
        this.searchTerritories = debounce(this.searchTerritoriesDebouncer, 500)
    },
}
</script>

<style scoped>
    .filter-contents {
        max-height: 500px !important;
        overflow-x: auto !important;
        overflow-y: auto !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/EditLocation.vue